import { render, staticRenderFns } from "./AlarmAccept.vue?vue&type=template&id=3971024c&scoped=true&"
import script from "./AlarmAccept.vue?vue&type=script&lang=js&"
export * from "./AlarmAccept.vue?vue&type=script&lang=js&"
import style0 from "./AlarmAccept.vue?vue&type=style&index=0&id=3971024c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3971024c",
  null
  
)

export default component.exports